import { createFileRoute, redirect } from '@tanstack/react-router';
import { SignIn } from '@/pages/sign-in';
import z from '@/lib/zod';
import { SELECTED_TENANT } from '@/lib/constants/tokens';
import Cookies from 'js-cookie';
import { queryClient } from '@/api/common/client';
import { ensureAuthData } from '@/api/auth/auth-query';
import { resolvePostLoginTarget } from '@/lib/auth/post-login-redirect';
import {
  optionalBooleanParam,
  optionalStringParam,
} from '@/lib/zod-search-params';

function readSelectedTenant(): unknown {
  const cookie = Cookies.get(SELECTED_TENANT);
  if (!cookie) return null;

  try {
    return JSON.parse(cookie);
  } catch (error) {
    console.error('Error parsing tenant cookie:', error);
    Cookies.remove(SELECTED_TENANT);
    return null;
  }
}

// Schemi tolleranti: un `?redirect=1` o un parametro ripetuto non devono
// abbattere la pagina di login (vedi @/lib/zod-search-params).
export const signInSearchSchema = z.object({
  createTenant: optionalBooleanParam,
  redirect: optionalStringParam,
});

export const Route = createFileRoute('/sign-in')({
  validateSearch: signInSearchSchema,
  beforeLoad: async ({ search }) => {
    const data = await ensureAuthData(queryClient);
    if (!data.authenticated) return;

    if (!readSelectedTenant()) return;

    // Il redirect va lanciato FUORI dal parsing del cookie: un `throw` dentro
    // il try finirebbe nel catch e verrebbe scambiato per un cookie corrotto.
    throw redirect({ href: resolvePostLoginTarget(search.redirect) });
  },
  component: SignIn,
});
